import BaseService from './BaseService';

// Conta as requisições de tiles de cada mapa aberto e manda o acumulado da sessão
// ao backend. Ver docs/iniciativas/mapa-rede-croqui/contratos/api-contract-telemetria-mapa.md

const INTERVALO_ENVIO_MS = 60000;

const PROVEDORES = [
  [/(^|\.)arcgisonline\.com$/, 'ESRI_IMAGERY'],
  [/(^|\.)arcgis\.com$/, 'ESRI'],
  [/(^|\.)openfreemap\.org$/, 'OPENFREEMAP'],
  [/(^|\.)openstreetmap\.org$/, 'OSM'],
  [/(^|\.)googleapis\.com$/, 'GOOGLE'],
  [/(^|\.)maptiler\.com$/, 'MAPTILER'],
];

export function provedorDaUrl(url) {
  let host = '';
  try {
    host = new URL(url).hostname;
  } catch (error) {
    return 'OUTRO';
  }
  const achado = PROVEDORES.find(([regra]) => regra.test(host));
  return achado ? achado[1] : 'OUTRO';
}

// Tiles terminam em .../{z}/{x}/{y} ou .../{z}/{y}/{x}: o zoom é o antepenúltimo número.
export function zoomDaUrl(url) {
  const caminho = String(url || '').split(/[?#]/)[0];
  const numeros = caminho
    .split('/')
    .map((parte) => parte.replace(/\.[a-z0-9]+$/i, ''))
    .filter((parte) => /^\d+$/.test(parte));
  if (numeros.length < 3) return null;
  return Number(numeros[numeros.length - 3]);
}

function novoId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function enviarSessaoMapa(payload) {
  return BaseService.post({ url: 'telemetria/mapa/sessoes', data: payload });
}

export function criarMedidorMapa({ tela, nsirId, enviar = enviarSessaoMapa } = {}) {
  const sessaoId = novoId();
  const inicio = new Date().toISOString();
  const contagem = {};
  let viewport = null;
  let alterado = false;
  let encerrado = false;
  let timer = null;

  const registrar = (url, resourceType) => {
    if (encerrado) return;
    const provedor = provedorDaUrl(url);
    if (!contagem[provedor]) contagem[provedor] = { tiles: 0, outros: 0, porZoom: {} };
    const atual = contagem[provedor];
    if (resourceType === 'Tile') {
      atual.tiles += 1;
      const zoom = zoomDaUrl(url);
      if (zoom !== null) atual.porZoom[zoom] = (atual.porZoom[zoom] || 0) + 1;
    } else {
      atual.outros += 1;
    }
    alterado = true;
  };

  const payload = (parcial) => ({
    sessaoId,
    tela,
    nsirId: nsirId || null,
    inicio,
    fim: new Date().toISOString(),
    parcial,
    viewport,
    provedores: Object.keys(contagem).map((provedor) => ({
      provedor,
      tiles: contagem[provedor].tiles,
      outros: contagem[provedor].outros,
      porZoom: { ...contagem[provedor].porZoom },
    })),
  });

  const enviarAgora = (parcial) => {
    if (!alterado) return;
    alterado = false;
    Promise.resolve()
      .then(() => enviar(payload(parcial)))
      .catch(() => {
        alterado = true;
      });
  };

  const aoSairDaPagina = () => enviarAgora(false);

  return {
    sessaoId,
    transformRequest(url, resourceType) {
      registrar(url, resourceType);
      return undefined;
    },
    iniciar(map) {
      const canvas = map && map.getContainer ? map.getContainer() : null;
      viewport = {
        largura: canvas ? canvas.clientWidth : null,
        altura: canvas ? canvas.clientHeight : null,
        pixelRatio: typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1,
      };
      timer = setInterval(() => enviarAgora(true), INTERVALO_ENVIO_MS);
      if (typeof window !== 'undefined') window.addEventListener('pagehide', aoSairDaPagina);
    },
    encerrar() {
      if (encerrado) return;
      if (timer) clearInterval(timer);
      if (typeof window !== 'undefined') window.removeEventListener('pagehide', aoSairDaPagina);
      enviarAgora(false);
      encerrado = true;
    },
  };
}
